export default __webpack_public_path__ + "static/media/utracker.450a2bf8.jpg";